module.exports = __webpack_public_path__ + "static/index/img/baikal-604.f9c4515d.jpg";